import { render, staticRenderFns } from "./Recognitions.vue?vue&type=template&id=32e02b68"
import script from "./Recognitions.vue?vue&type=script&lang=js"
export * from "./Recognitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports